import { render, staticRenderFns } from "./AfMarcaComponent.vue?vue&type=template&id=ccbb0068&"
import script from "./AfMarcaComponent.vue?vue&type=script&lang=js&"
export * from "./AfMarcaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports